/* Add   fn_getProjectBusinessInsights, fn_saveProjectBusinessInsights,   fn_getProjectDebriefs, fn_saveProjectDebrief,   fn_getRecordNo, fn_getProjectNo Jan 25, 2022 */
/* Add fn_copyAttachment Mar 13, 2022 */
/* Add proposal Apr 3, 2022 */
/* Add fn_getTaskResources  May 10, 2022 */
/* Add Tast Comments Aug 16, 2022*/
/* Add  fn_getMapLocation  Oct 15, 20022 */
/* Add Proposal Templates Jan 15, 2023 */
/* Add fn_postRaiseEvent Apr 29,2023 */
/* Add customData Jul 31,2023 */
/* Add  opportunityTeam, projectTeam  Dec 30, 2023 */
/* Add fn_getAppReports,fn_saveAppReport Feb 3, 2024 */
/* Add appNotes Feb 17, 2024 */
/* Add fn_saveDataOrder to settings  Feb 28, 2025 */
/* Add resumeData to fn_saveRecord to settings, fn_callChatGPT,  Feb 28, 2026 */
/* Add fn_getConstructionDates Mar 31, 2026 */
/* Add fn_saveCompetitorBids  Apr 11, 2026 */
/* Add completeProposals,proposalService,proposalFiles June 22, 2026 */
/* Add fn_getRevenueForecastProjects Aug 8, 2026 */
/* Add fn_getPipelineData,fn_updateOpportunityColumn Sep 5, 2026 */
/* Add fn_getMeetings,fn_updateMeeting,fn_updateMeetingColumn Sep 19, 2026 */
/* Add fn_saveLocation for Reminder time zone Oct 3, 2026 */
import axios from "axios";
import {api_baseURL, client_subdomain, fn_get_IdToken} from "@/utils/init.js";

let baseURL = api_baseURL;
let subdomain = client_subdomain;

//Individual Imports
export {
   fn_getRecord,
   fn_saveRecord,
   fn_deleteRecord,
   fn_updateRecordProp,
   fn_checkDuplicates,

   fn_getDecisions,
   fn_saveDecision,
   fn_getBusinessInsights,
   fn_saveBusinessInsights,
   fn_getDebriefs,
   fn_saveDebrief,
   

   fn_getTableData,
   fn_getDashboardData,
   fn_getCalendarData,
   fn_simpleSearch,

   fn_getReferenceData,
   fn_getAppTenantSettings,
   fn_getAppUserSettings,
   fn_saveAppUserSetting,

   fn_getUserReminders,
   fn_getReminderOptions,
   fn_saveReminderOptions,
   fn_dismissReminder,

   attachments,
   salesGoals,
   settings,


   fn_getAdminData,
   fn_saveAdminData,
   
   fn_getProjectBusinessInsights,
   fn_saveProjectBusinessInsights,
   fn_getRecordNo,
   fn_getProjectNo,
   fn_AsyncGET,
   photos,
   
   fn_getProjectDebriefs,
   fn_saveProjectDebrief,
   proposals,
   fn_getTaskResources,
   fn_getMapPosition,
   
   fn_getStaffingData,
   fn_saveStaffingData,
   fn_getAllStaffingData,
   
   
   fn_getProposalTemplates,
   fn_processEvent,
   
   fn_getAppReports,
   fn_saveAppReport,
   fn_getOpportunityTeam,
   fn_saveOpportunityTeam,
   fn_getProjectTeam,
   fn_saveProjectTeam,
   fn_getAppNotes,
   fn_saveAppNotes,
   fn_deleteAppNote,
   fn_callAI,
   fn_AIProcessFile,
   fn_getConstructionDates,
   fn_saveCompetitorBids,
   proposalService,
   fn_getRevenueForecastData,
   fn_saveRevenueForecastData,
   fn_getPipelineData,
   fn_updateOpportunityColumn,
   
   fn_getMeetings,
   fn_saveMeeting,
   fn_updateMeetingColumn,
   fn_saveLocation,
};


//Ajax Request Helpers, not exported
async function fn_AsyncGET(cmdPath, params) {
   return fn_get_IdToken().then(idTkn => {
      return axios({
         method: "GET",
         url: baseURL + (cmdPath || ''),
         // contentTYpe: 'text/plain',
         params: params, //"Query"
         headers: {
            subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {return resp.data;}).catch(err => {return fn_catchHelper(err);});
   });
}
async function fn_AsyncGETBuffer(cmdPath, params) {
   return fn_get_IdToken().then(idTkn => {
      return axios({
         method: "GET",
         url: baseURL + (cmdPath || ''),
         // contentTYpe: 'text/plain',
         params: params, //"Query"
		 responseType: 'arraybuffer',
         headers: {
            subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {return resp.data;}).catch(err => {return fn_catchHelper(err);});
   });
}

async function fn_AsyncPOST(cmdPath, data) {
   return fn_get_IdToken().then(idTkn => {
      return axios({
         method: "POST",
         url: baseURL + cmdPath,
         contentTYpe: 'application/json; charset=utf-8',
         data,
         headers: {
            subdomain,
            "Authorization": "Bearer " + idTkn,
            // "Access-Control-Allow-Origin": "*",
            // "Access-Control-Allow-Credentials": "true",
            // "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
            // "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization"
         },
      }).then(resp => {return resp.data;}).catch(err => {return fn_catchHelper(err);});
   });
}
async function fn_AsyncPUT(cmdPath, params) {
   return fn_get_IdToken().then(idTkn => {
      return axios({
         method: "PUT",
         url: baseURL + cmdPath,
         // contentTYpe: 'text/plain',
         params: params, //"Query"
         headers: {
            subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {return resp.data;}).catch(err => {return fn_catchHelper(err);});
   });
}
async function fn_AsyncPOSTUpload(cmdPath, formData) {
   return fn_get_IdToken().then(idTkn => {
      let url = baseURL + cmdPath;
      return axios.post(url, formData, {
         headers: {
            contentType: 'multipart/form-data',
            subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {return resp.data;}).catch(err => {return fn_catchHelper(err);});
   });
}
async function fn_AsyncGETDownload(cmdPath) {
   return fn_get_IdToken().then(idTkn => {
      let url = baseURL + cmdPath;
      return fetch(url, {
         method: 'GET',
         headers: {
            subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {
         if (resp.ok) {
            return resp.blob();
         }
         else {
            return resp.text().then(err => {throw new Error(err);});
         }
      }).then(blob => {
         return {
            objUrl: URL.createObjectURL(blob),
            contentType: blob.type,
         };
      }).catch(err => {
         return {
            error: err.message,
         };
      });
   });
}
async function fn_AsyncDELETE(cmdPath, params) {
   return fn_get_IdToken().then(idTkn => {
      return axios({
         method: "DELETE",
         url: baseURL + cmdPath,
         // contentTYpe: 'text/plain',
         params: params, //"Query"
         headers: {
            subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {return resp.data;}).catch(err => {return fn_catchHelper(err);});
   });
}
function fn_catchHelper(err) {
	console.log('err');
	console.log(err);
   let rd = (err.response || {}).data;
   let ignoreRD = !rd || rd.startsWith('<!DOCTYPE html>');
   return {
      error: err.message + (ignoreRD ? '' : ' - ' + rd),
   };
}



function fn_getReferenceData() {
   return fn_AsyncGET('referenceData');
}
function fn_getAppTenantSettings(category, prop) {
   return fn_AsyncGET('appTenantSettings', {category, prop});
}
function fn_getAppUserSettings(category, prop) {
   return fn_AsyncGET('appUserSettings', {category, prop});
}
function fn_saveAppUserSetting(settingData) {
   return fn_AsyncPOST('appUserSetting', settingData);
}






////////////////////
//Single Record
////////////////////
function fn_getRecord(appEntName, recNoTaskId) {
   return fn_AsyncGET(appEntName + '/' + recNoTaskId);
}
function fn_saveRecord(appEntName, recId, recData) {

   let recDataSend = {};

   //Only send needed info, reduce payload
   Object.keys(recData).forEach(key => {
      let rd = recData[key];
      if (rd == null || rd == undefined) return;

      if (['updatedBy', 'updatedUTC', 'createdBy', 'createdUTC', 'addedBy', 'addedUTC'].indexOf(key) > -1) return;

      if (['taskChecklist'].indexOf(key) > -1) {
         if (rd.length > 0) recDataSend[key] = rd;
         // recDataSend[key] = JSON.stringify(rd);
         return;
      }
	if (['comments'].indexOf(key) > -1) {
			console.log('customData found');
         if (rd.length > 0) recDataSend[key] = rd;
         // recDataSend[key] = JSON.stringify(rd);
         return;
      }
	if (['customData','resumeData'].indexOf(key) > -1) {
         if(rd) recDataSend[key] = rd;
         // recDataSend[key] = JSON.stringify(rd);
         return;
      }
      let typ = typeof (rd);
      if (typ == 'object') {
         if (Array.isArray(rd)) {

            recDataSend[key] = [];
            rd.forEach(elem => {
               let idKey = Object.keys(elem).filter(x => x.endsWith('Id'))[0];
               recDataSend[key].push({[idKey]: elem[idKey]});
            });
         }
         else {
            let idKey = Object.keys(rd).filter(x => x.endsWith('Id'))[0];
            recDataSend[key] = {[idKey]: rd[idKey]};
         }
      }
      else {
         recDataSend[key] = rd || null; //send null for blank values. 0s come as '0'
      }
   });

   return fn_AsyncPOST(appEntName + '/' + (recId || 'new'), recDataSend);
}
function fn_deleteRecord(appEntName, recId) {
	return fn_AsyncPUT(appEntName + '/delete/' + recId);
}
function fn_updateRecordProp(appEntName, recId, prop, value) {
	return fn_AsyncPUT(appEntName + '/update/' + recId, {prop, value});
}
function fn_checkDuplicates(appEntName, recData) {
	return fn_AsyncPOST('checkDuplicates/' + appEntName, recData);
}

function fn_getDecisions(opportunityId) {
   return fn_AsyncGET('decisions/' + opportunityId, null);
}
function fn_saveDecision(opportunityId, decsData) {
   return fn_AsyncPOST('decision/' + opportunityId, decsData);
}
function fn_getBusinessInsights(opportunityId) {
   return fn_AsyncGET('businessInsights/' + opportunityId, null);
}
function fn_saveBusinessInsights(opportunityId, biData) {
   return fn_AsyncPOST('businessInsights/' + opportunityId, biData);
}
function fn_getDebriefs(opportunityId) {
   return fn_AsyncGET('debriefs/' + opportunityId, null);
}
function fn_saveDebrief(opportunityId, decsData) {
   return fn_AsyncPOST('debrief/' + opportunityId, decsData);
}

function fn_getProjectDebriefs(projectId) {
   return fn_AsyncGET('projectDebriefs/' + projectId, null);
}
function fn_saveProjectDebrief(projectId, decsData) {
   return fn_AsyncPOST('projectDebrief/' + projectId, decsData);
}

function fn_getTableData(appEntName, params) {
   return fn_AsyncGET(appEntName, params);
}
function fn_getDashboardData(params) {
   return fn_AsyncGET('dashboardData', params);
}
function fn_getCalendarData(params) {
   return fn_AsyncGET('calendarData', params);
}
function fn_simpleSearch(params) {
   return fn_AsyncGET('simpleSearch', params);
}


//Reminders
function fn_getUserReminders() {
   return fn_AsyncGET('userReminders');
}
function fn_getReminderOptions(context, contextId) {
   let url = `reminderOptions/${context}/${contextId}`;
   return fn_AsyncGET(url);
}

function fn_saveReminderOptions(context, contextId, options) {
   let url = `reminderOptions/${context}/${contextId}`;
   return fn_AsyncPOST(url, options);
}
function fn_dismissReminder(context, params) {
   let url = `dismissReminder/${context}`;
   return fn_AsyncPOST(url, params);
}



let attachments = {
   fn_getAttch: (params) => {
      return fn_AsyncGET('attachments', params);
   },
   fn_saveAttchFldr: (params) => {
      return fn_AsyncPOST('attachmentFolder', params);
   },
   fn_saveAttch: (params) => {
      return fn_AsyncPOST('attachment', params);
   },
   fn_upldAttch: (files, params) => {
      let formData = new FormData();
      Object.keys(params).forEach(x => formData.append(x, params[x]));
      files.forEach(f => {
         let isFldr = !f.type && f.size % 4096 == 0;
         if (!isFldr) {
            formData.append(f.name, f);
         }
      });
      return fn_AsyncPOSTUpload('attachments/upload', formData);
   },
   fn_dlAttch: (attachmentId) => {
      return fn_AsyncGETDownload('attachment/download/' + attachmentId);
   },
   fn_dlAttchFldr: (params) => {
      let qry = Object.keys(params).map(k => k + '=' + (params[k] || '')).join('&');
      return fn_AsyncGETDownload('attachmentFolder/download/?' + qry);
   },
    fn_copyAttachment: (params) => {
      return fn_AsyncPOST('attachment/copy', params);
   },
};

let salesGoals = {
   fn_getSG: (params, qry) => {
      return fn_AsyncGET('salesGoals' + (qry ? `/${qry}` : ''), params);
   },
   fn_saveSG: (sgId, sgData) => {
      return fn_AsyncPOST('salesGoal/' + (sgId || 'new'), sgData);
   },
   fn_delSG: (sgId, params) => {
      return fn_AsyncPUT('salesGoal/delete/' + sgId, params);
   },
   fn_saveSGN: (sgId, sgnData) => {
      return fn_AsyncPOST('salesGoalNote/' + sgId, sgnData);
   },
};

let settings = {
   fn_getData: (context, category) => {
      let qry = (category ? '?category=' + category : '');
      return fn_AsyncGET('settingData/' + context + qry);
   },
   fn_saveData: (context, category, settingData) => {
      let qry = (category ? '?category=' + category : '');
      return fn_AsyncPOST('settingData/' + context + qry, settingData);
   },
   fn_delData: (context, contextId) => {
      return fn_AsyncPUT('settingData/delete/' + context, {contextId});
   },
    fn_saveDataOrder: (context, category, settingsDataOrder) => {
      let qry = (category ? '?category=' + category : '');
      return fn_AsyncPOST('settingDataOrder/' + context + qry, settingsDataOrder);
   }

};


//Admin
function fn_getAdminData(context, params) {
   return fn_AsyncGET('admin/' + context, params);
}
function fn_saveAdminData(context, adminData) {
   return fn_AsyncPOST('admin/' + context, adminData);
}

//Project Business Insights
function fn_getProjectBusinessInsights(projectId) {
   return fn_AsyncGET('projectBusinessInsights/' + projectId, null);
}
function fn_saveProjectBusinessInsights(projectId, biData) {
   return fn_AsyncPOST('projectBusinessInsights/' + projectId, biData);
}

// Get Next Record No for Projects, Opportunities.
function fn_getRecordNo(params) {
   return fn_AsyncGET('recordNo',params);
}

async function fn_getProjectNo(params) {
 return fn_AsyncGET('getProjectNo',params);
}

let photos = {
   fn_getPhoto: (params) => {
      return fn_AsyncGET('photo', params);
   },
	fn_savePhotoFolder: (params) => {
		return fn_AsyncPOST('photoFolder', params);
	},
	fn_savePhoto: (params) => {
		return fn_AsyncPOST('photo', params);
	},
   fn_uploadPhoto: (files, params) => {
      let formData = new FormData();
      Object.keys(params).forEach(x => formData.append(x, params[x]));
      files.forEach(f => {
         let isFldr = !f.type && f.size % 4096 == 0;
         if (!isFldr) {
            formData.append(f.name, f);
         }
      });
      return fn_AsyncPOSTUpload('photos/upload', formData);
   },
   fn_downloadPhoto: (photoId) => {
      return fn_AsyncGETDownload('photo/download/' + photoId);
   },
  
};
let proposals = {
   fn_getProposal: (params) => {
      return fn_AsyncGET('proposal', params);
   },
	fn_saveProposal: (params) => {
		return fn_AsyncPOST('proposal', params);
	},
};

// Get Task Resources
function fn_getTaskResources(params) {
   return fn_AsyncGET('taskResources',params);
}

//Map View
async function fn_getMapPosition(params) {
  return fn_AsyncGET('mapPosition',params);
}

//StaffingData
async function fn_saveStaffingData(params) {
  return fn_AsyncPOST('staffingData',params);
}

async function fn_getStaffingData(params) {
  return fn_AsyncGET('staffingData',params);
}

async function fn_getAllStaffingData(params) {
  return fn_AsyncGET('allStaffingData', params);
}

// Proposal Templates
function fn_getProposalTemplates(){
	fn_AsyncGET('referenceData').then(resp => {
		console.log("in fn_getProposalTemplates");
		console.log(resp);
      return resp.proposalTemplates;
      });
   }
   
// Process Front end App Events
function fn_processEvent(params){
		console.log("in fn_processEvent");
		fn_AsyncPOST('processEvent', params).then(resp => {
		return true;
		});
}



//opportunityTeam
async function fn_getOpportunityTeam(params) {
  return fn_AsyncGET('opportunityTeam',params);
}
async function fn_saveOpportunityTeam(params) {
  return fn_AsyncPOST('opportunityTeam',params);
}

//Project Team
async function fn_getProjectTeam(params) {
  return fn_AsyncGET('projectTeam',params);
}
async function fn_saveProjectTeam(params) {
  return fn_AsyncPOST('projectTeam',params);
}

//appReports
async function fn_getAppReports(params) {
  return fn_AsyncGET('appReport',params);
}
async function fn_saveAppReport(params) {
  return fn_AsyncPOST('appReport',params);
 } 
  
//appNotes
async function fn_getAppNotes(params) {
	return fn_AsyncGET('appNotes',params);
}
async function fn_saveAppNotes(params) {
	return fn_AsyncPOST('appNotes',params);
}
function fn_deleteAppNote(recId) {
	return fn_AsyncPUT('appNote/delete/' + recId);
}

// AI Layer
function fn_callAI(params) {
	return fn_AsyncPOST('callAI',params);
}
function fn_AIProcessFile(params) {
	return fn_AsyncPOSTUpload('AIProcessFile',params);
}

//constructionDates
async function fn_getConstructionDates() {
  return fn_AsyncGET('constructionDates',null);
}


//Competitor Bids
async function fn_saveCompetitorBids(params) {
  return fn_AsyncPOST('competitorBids',params);
}

// Proposal Service
let proposalService = {
	
    async fetchProjects(page, limit, search, marketSegmentId, from, to, teamMemberId) {
        const params = new URLSearchParams({ page, limit });
        if (search) params.append('search', search);
        if (marketSegmentId && marketSegmentId !== 'All Segments') params.append('marketSegmentId', marketSegmentId);
        if (from) params.append('startDate', from);
        if (to) params.append('endDate', to);
        if (teamMemberId) params.append('teamMemberId', teamMemberId);
		return fn_AsyncGET(`proposal/all-projects?${params.toString()}`);
        //return axiosInstance.get(`/all-projects?${params.toString()}`);
        
    },

    async fetchMembers(page, limit, search) {
        const params = new URLSearchParams({ page, limit });
        if (search) params.append('search', search);
		return fn_AsyncGET(`proposal/all-teamMembers?${params.toString()}`);
        //return axiosInstance.get(`/all-teamMembers?${params.toString()}`);
    },

    async fetchOpportunityById(id) {
		return fn_AsyncGET(`proposal/opportunity/${id}`);
        //return axiosInstance.get(`/opportunity/${id}`);
    },

    async fetchMarketSegments(page, limit) {
		return fn_AsyncGET(`proposal/all-marketSegments?page=${page}&limit=${limit}`);
        //return axiosInstance.get(`/all-marketSegments?page=${page}&limit=${limit}`);
    },

    async generateAiResponse(prompt) {
		return fn_AsyncPOST(`proposal/ai/generate`, prompt);
        //return axiosInstance.post(`/ai/generate`, prompt);
    },
    async fetchUserData() {
		return fn_AsyncGET(`proposal/setting`);
        //return axiosInstance.get(`/setting`);
    },
	async  fn_getProposal(params){
      return fn_AsyncGET('completeProposal', params);
   },
	async fn_saveProposal(params) {
		return fn_AsyncPOST('completeProposal', params);
	},
	
 async fn_getProposalFile(params) {
      const resp = await fn_AsyncGETBuffer('proposalFile', params);
	  return resp;
   },
 async fn_uploadProposalFile(files,params) {
      let formData = new FormData();
      Object.keys(params).forEach(x => formData.append(x, params[x]));
      files.forEach(f => {
         let isFldr = !f.type && f.size % 4096 == 0;
         if (!isFldr) {
            formData.append("file", f);
         }
      });
      let resp= await fn_AsyncPOSTUpload('proposalFile/upload', formData);
	  console.log('fn_uploadProposalFile resp');
	  console.log(resp);
	  return resp.fileName.toString();
   },
   
 async  fn_deleteProposalFile(params) {
      const resp = await fn_AsyncDELETE('proposalFile', params);
	  return resp;
   },

};


//Revenue Forecast
async function fn_getRevenueForecastData(params){
      return fn_AsyncGET('revenueForecastData', params);
}

 async function fn_saveRevenueForecastData(params){
      return fn_AsyncPOST('revenueForecastData', params);
}

//Pipeline Data for HomeDashboard
async function fn_getPipelineData(params){
      return fn_AsyncGET('pipelineData', params);
}
async function fn_updateOpportunityColumn(params){
	return fn_AsyncPOST('updateOpportunityColumn', params);
}

//Meetings
async function fn_getMeetings(params){
      return fn_AsyncGET('meetings', params);
}
async function fn_saveMeeting(params){
      return fn_AsyncGET('meeting', params);
}
async function fn_updateMeetingColumn(params){
	return fn_AsyncPOST('updateMeetingColumn', params);
}

//Location
async function fn_saveLocation(params){
      return fn_AsyncPOST('location', params);
}

  
   



